import { useMemo } from "react";

import { CommunicationActivity } from "../../../api/services";

export const useCommActivity = (activity: CommunicationActivity) => {
  const { commMethods, commType } = activity;

  return useMemo(() => {
    const methods = commMethods.join(", ");
    return {
      title: `${commType} (${methods})`,
    };
  }, [commMethods, commType]);
};
